"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const Destination_1 = require("./Destination");
const Location_1 = require("./Location");
const Polygon_1 = require("./Polygon");
const Zone_1 = require("./Zone");
function placeDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        destinations: (0, unwrap_1.default)(object.destinations, Destination_1.destinationsDeserialize),
        couponCode: (0, unwrap_1.default)(object.couponCode, deserializeString_1.deserializeString),
        invoiceFormulaId: (0, unwrap_1.default)(object.invoiceFormulaId, deserializeString_1.deserializeString),
        location: (0, Location_1.locationDeserialize)(object.location),
        name: (0, deserializeString_1.deserializeString)(object.name),
        payoutFormulaId: (0, unwrap_1.default)(object.payoutFormulaId, deserializeString_1.deserializeString),
        polygons: (0, unwrap_1.default)(object.polygons, Polygon_1.polygonsDeserialize),
        zones: (0, unwrap_1.default)(object.zones, Zone_1.zonesDeserialize),
    };
}
exports.placeDeserialize = placeDeserialize;
